import { render, staticRenderFns } from "./typeComponents.vue?vue&type=template&id=6db78260&"
import script from "./typeComponents.vue?vue&type=script&lang=js&"
export * from "./typeComponents.vue?vue&type=script&lang=js&"
import style0 from "./typeComponents.vue?vue&type=style&index=0&id=6db78260&prod&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports